const translations = {
  en: {
    nav: {
      home:           'Home',
      services:       'Services',
      projects:       'Projects',
      sustainability: 'Sustainability',
      about:          'About Us',
      contact:        'Contact',
      gallery:        'News & Updates',
      getQuote:       'Get a Quote',
    },
    hero: {
      badge:           'Your Renewable Energy Partner',
      title:           'Integrated Renewable Energy Solutions',
      subtitle:        "JSISCO – Jordan's South Integrated Systems Co. Leading in solar installations, monitoring & protection systems, electrical works, and industrial maintenance.",
      tagline:         'Power is consumable, yet it can be conserved in the right hands. We are here to make that possible.',
      exploreServices: 'Our Services',
      getQuote:        'Get Free Quote',
    },
    stats: {
      systemsInstalled: 'Solar Systems Installed',
      capacity:         'Total Capacity Delivered',
      panelCleaning:    'Panel Cleaning Services',
      monitoring:       'Monitoring Systems',
      smartHome:        'Smart Home Installations',
      schools:          'Including 3 schools powered',
    },
    home: {
      services: {
        title:   'Our Services',
        subtitle: 'Comprehensive renewable energy and electrical solutions tailored to your needs',
        viewAll: 'View All Services',
      },
      projects: {
        title:   'Featured Projects',
        subtitle: 'A showcase of our successfully completed projects across Jordan',
        viewAll: 'View All Projects',
      },
      whyUs: {
        title:   'Why Choose JSISCO?',
        subtitle: 'We combine proven expertise, premium quality, and long-term commitment',
      },
    },
    whyUs: {
      experience: {
        title: 'Proven Experience',
        desc:  'Over 10 years delivering renewable energy solutions across southern Jordan',
      },
      quality: {
        title: 'Premium Quality',
        desc:  'We use only certified, top-tier equipment from trusted global manufacturers',
      },
      warranty: {
        title: 'Full Warranty',
        desc:  'Comprehensive warranty and after-sales support on all our installations',
      },
      support: {
        title: '24/7 Support',
        desc:  'Round-the-clock technical support to keep your systems running at peak performance',
      },
    },
    cta: {
      title:    'Ready to Switch to Solar Energy?',
      subtitle: 'Get a free consultation and discover how JSISCO can transform your energy needs',
      button:   'Get a Free Quote',
      phone:    'Or Call Us',
    },
    services: {
      title:          'Our Services',
      subtitle:       'Expert renewable energy and electrical solutions for every need',
      solar:          'Solar System Installation',
      solarDesc:      'Professional design and installation of solar PV systems for residential, commercial, and industrial use',
      renewable:      'Renewable Energy Solutions',
      renewableDesc:  'Comprehensive renewable energy consulting, design, and implementation services',
      monitoring:     'Monitoring & Protection Systems',
      monitoringDesc: 'Advanced monitoring, control, and protection systems for electrical and solar installations',
      electrical:     'Electrical Works',
      electricalDesc: 'Full-scope electrical works including wiring, panels, transformers, and distribution systems',
      maintenance:    'Industrial Maintenance',
      maintenanceDesc:'Preventive and corrective maintenance for industrial electrical and mechanical systems',
      fireAlarm:      'Fire Alarm Systems',
    },
    projects: {
      title:   'Our Projects',
      subtitle: 'A portfolio of successful projects across southern Jordan',
      seeMore: 'View Project',
    },
    about: {
      title:    'About JSISCO',
      subtitle: "Jordan's South Integrated Systems Co. — Your trusted partner in renewable energy",
      credential: {
        years:          '2017 – 2026',
        classification: 'A-Class Company — Licensed by EMRC (License No. 58)',
        unique:         'The only fully equipped systems installation company in the southern territory of Jordan.',
      },
      ourStory: {
        title:    'Our Story',
        content:  'JSISCO was founded with a clear vision: to bring reliable, affordable, and sustainable energy solutions to southern Jordan. Starting with electrical works, we quickly expanded into solar energy systems and industrial maintenance.',
        content2: 'Today we are one of the leading renewable energy companies in the region, with hundreds of completed projects and a team of certified engineers and technicians dedicated to excellence.',
        content3: 'With expertise across various fields, we provide smart solutions in the form of systems and programs designed to conserve power and reduce costs for our customers — helping them embrace energy-efficient solutions for a seamless, cost-effective lifestyle.',
      },
      mission: {
        title:   'Our Mission',
        content: 'To lead community transformation toward renewable energy adoption by delivering reliable, efficient, and advanced alternative energy systems. We aim to encourage individuals, businesses, and institutions to implement clean energy solutions that reduce climate change impacts and contribute to a more sustainable future.',
      },
      vision: {
        title:   'Our Vision',
        content: 'To make renewable energy accessible to all and contribute to a fossil fuel free future.',
      },
      values: {
        title: 'Our Values',
        customerService:      { title: 'Customer Service',              content: 'Responsive, attentive support at every step of the project' },
        innovation:            { title: 'Innovation',                    content: 'Embracing the latest technologies in renewable energy' },
        teamwork:              { title: 'Teamwork',                      content: 'Collaborating closely to deliver every project as one team' },
        sustainability:        { title: 'Sustainability',                content: 'Building a cleaner, more sustainable energy future' },
        customerSatisfaction: { title: 'Customer Satisfaction',         content: "Driven by results that exceed our clients' expectations" },
        qualityOfService:     { title: 'Quality of Service',            content: 'Committed to the highest standards in every project' },
        commitment:            { title: 'Commitment',                    content: 'Reliable follow-through from planning to completion' },
        professionalism:       { title: 'Professionalism & Competence',  content: 'Certified engineers and technicians dedicated to excellence' },
      },
      community: {
        title:         'Community Empowerment',
        subtitle:      'Capacity Building & Workforce Development',
        intro:         'At JSISCO, we believe that sustainable energy transformation begins with empowering people. We actively invest in developing young professionals and strengthening local technical capacity in the renewable energy sector.',
        quote:         'Power is consumable, yet human potential is expandable. We invest in both.',
        programsTitle: 'Training Programs',
        programs: [
          { title: 'Field Installation & Practical Execution', desc: 'Hands-on solar system installation and on-site implementation.' },
          { title: 'Technical & Software Training',            desc: 'AutoCAD, SketchUp, PV Monitoring & Design Systems.' },
          { title: 'Occupational Health & Safety',             desc: 'Professional safety standards and risk prevention practices.' },
        ],
        stats: {
          hussein: { number: '25', label: 'Students — Al-Hussein Bin Talal University' },
          balqa:   { number: '10', label: 'Students — Al-Balqa Applied University & Community Colleges' },
        },
        employment: { title: 'Employment Opportunity', desc: 'Selected trainees were successfully hired and are currently working at JSISCO.' },
      },
    },
    contact: {
      title:   'Contact Us',
      subtitle: "We're here to answer your questions and help you get started",
      success: 'Thank you! We will get back to you within 24 hours.',
      error:   'Something went wrong. Please try again or call us directly.',
      form: {
        name:    'Your Name',
        email:   'Email Address',
        phone:   'Phone Number',
        subject: 'Subject',
        message: 'Your Message',
        submit:  'Send Message',
      },
      info: {
        title:      'Contact Information',
        phone:      'Phone',
        email:      'Email',
        address:    'Address',
        hours:         'Business Hours',
        hoursWeekdays: 'Sunday to Thursday & Saturday',
        hoursShifts:   '9:00 AM–3:00 PM & 5:00 PM–10:00 PM',
        hoursFriday:   'Friday: Closed',
        social:        'Follow Us',
      },
    },
    quote: {
      title:   'Request a Free Quote',
      subtitle: "Tell us about your project and we'll get back to you within 24 hours",
      success: 'Quote request submitted! We will contact you within 24 hours.',
      error:   'Failed to submit. Please try again or call us directly.',
      form: {
        name:            'Full Name',
        email:           'Email Address',
        phone:           'Phone Number',
        company:         'Company / Organization',
        serviceType:     'Service Required',
        selectService:   'Select a service',
        projectDetails:  'Project Details',
        budget:          'Estimated Budget (JD)',
        timeline:        'Expected Timeline',
        attachments:     'Attachments',
        attachmentsNote: 'Attach relevant documents (max 5 files, 5 MB each)',
        submit:          'Submit Request',
      },
    },
    footer: {
      description: "Jordan's South Integrated Systems Co. — Specialized in renewable energy, solar installations, electrical works, and industrial maintenance.",
      quickLinks:  'Quick Links',
      services:    'Services',
      contact:     'Contact Us',
      rights:      'All rights reserved',
      registration: 'Reg. No. 200159018',
    },
    partners: {
      strategicTitle: 'Strategic Partners',
      suppliersTitle: 'Certified Partners & Suppliers',
      viewInitiative: 'View Initiative',
      maan: {
        name: "Greater Ma'an Municipality",
        desc: "Partnering with JSISCO on the Ma'an waste-sorting and environmental initiative.",
      },
    },
    sustainability: {
      badge:    'Environmental Initiative',
      title:    'Sustainability & Community Responsibility',
      subtitle: "Towards a more beautiful, cleaner Ma'an",
      socialResponsibility: {
        intro:   'At JSISCO, we operate responsibly to address environmental and social challenges.',
        points: [
          'Reducing carbon emissions',
          'Supporting sustainable water purification systems',
          'Promoting clean energy awareness',
          'Building long-term value for clients, employees, and communities',
        ],
        closing: 'Our responsibility goes beyond projects — it extends to impact.',
      },
      initiative: {
        title: "Ma'an Waste Sorting Station",
        body:  "JSISCO has begun collecting cardboard in preparation for launching a waste-sorting station in Ma'an — the first step toward source-sorting and collecting waste, which will expand to include other materials over time. This initiative aims to reduce environmental pollution and move toward a more beautiful, cleaner Ma'an.",
      },
      partner: {
        label: 'In partnership with',
        name:  "Greater Ma'an Municipality",
      },
      participate: {
        title: 'How You Can Help',
        steps: [
          { title: 'Sort at the Source',    desc: 'Separate cardboard and recyclables at home or your business before disposal.' },
          { title: 'Use Designated Bins',   desc: 'Place sorted waste in the collection points designated for sorted materials, not regular street bins.' },
          { title: 'More Materials Coming', desc: 'The program will expand beyond cardboard to include other recyclable materials soon, God willing.' },
        ],
      },
      cta: {
        title:    'Want to Support This Initiative?',
        subtitle: "Whether you're a resident, business, or organization in Ma'an, get in touch to learn how you can get involved.",
      },
    },
    admin: {
      login: {
        title:       'JSISCO Admin',
        subtitle:    'Enter password to continue',
        placeholder: 'Password',
        incorrect:   'Incorrect password',
        submit:      'Enter',
      },
      header: {
        title:    'JSISCO Admin',
        subtitle: 'Submissions Dashboard',
        logout:   'Logout',
      },
      tabs: {
        contacts: 'Contact Messages',
        quotes:   'Quote Requests',
      },
      loading:         'Loading…',
      connectionError: 'Could not connect to the backend. Make sure it is running.',
      noSubmissions:   'No submissions yet',
      fields: {
        name:         'Name',
        email:        'Email',
        phone:        'Phone',
        subject:      'Subject',
        status:       'Status',
        date:         'Date',
        service:      'Service',
        budget:       'Budget',
      },
      detail: {
        message:        'Message',
        projectDetails: 'Project Details',
      },
      status: {
        pending:          'Pending',
        contacted:        'Contacted',
        resolved:         'Resolved',
        reviewed:         'Reviewed',
        quoted:           'Quoted',
        accepted:         'Accepted',
        rejected:         'Rejected',
      },
    },
  },

  ar: {
    nav: {
      home:           'الرئيسية',
      services:       'الخدمات',
      projects:       'المشاريع',
      sustainability: 'الاستدامة',
      about:          'من نحن',
      contact:        'اتصل بنا',
      gallery:        'أخبار ومستجدات',
      getQuote:       'احصل على عرض',
    },
    hero: {
      badge:           'شريككم في الطاقة المتجددة',
      title:           'حلول الأنظمة المتكاملة',
      subtitle:        'شركة الجنوب للأنظمة المتكاملة — رواد تركيب أنظمة الطاقة الشمسية وأنظمة المراقبة والحماية والأعمال الكهربائية والصيانة الصناعية.',
      tagline:         'الطاقة قابلة للاستهلاك، لكن يمكن الحفاظ عليها في الأيدي الصحيحة. نحن هنا لنجعل ذلك ممكناً.',
      exploreServices: 'خدماتنا',
      getQuote:        'احصل على عرض مجاني',
    },
    stats: {
      systemsInstalled: 'نظام طاقة شمسية مُركّب',
      capacity:         'إجمالي القدرة المُنجزة',
      panelCleaning:    'خدمة تنظيف ألواح',
      monitoring:       'نظام مراقبة',
      smartHome:        'تركيب منزل ذكي',
      schools:          'من ضمنها 3 مدارس تم تزويدها بالطاقة الشمسية',
    },
    home: {
      services: {
        title:   'خدماتنا',
        subtitle: 'حلول شاملة للطاقة المتجددة والأعمال الكهربائية مصممة حسب احتياجاتك',
        viewAll: 'عرض جميع الخدمات',
      },
      projects: {
        title:   'مشاريعنا المميزة',
        subtitle: 'نماذج من مشاريعنا المنجزة بنجاح في أرجاء الأردن',
        viewAll: 'عرض جميع المشاريع',
      },
      whyUs: {
        title:   'لماذا تختار JSISCO؟',
        subtitle: 'نجمع بين الخبرة الموثّقة والجودة العالية والالتزام طويل الأمد',
      },
    },
    whyUs: {
      experience: {
        title: 'خبرة موثّقة',
        desc:  'أكثر من 10 سنوات في تقديم حلول الطاقة المتجددة في جنوب الأردن',
      },
      quality: {
        title: 'جودة عالية',
        desc:  'نستخدم فقط المعدات المعتمدة من أفضل المصنّعين العالميين الموثوقين',
      },
      warranty: {
        title: 'ضمان شامل',
        desc:  'ضمان كامل ودعم ما بعد البيع على جميع تركيباتنا',
      },
      support: {
        title: 'دعم 24/7',
        desc:  'دعم فني على مدار الساعة للحفاظ على أنظمتك في أفضل حال',
      },
    },
    cta: {
      title:    'هل أنت مستعد للتحول إلى الطاقة الشمسية؟',
      subtitle: 'احصل على استشارة مجانية واكتشف كيف يمكن لـ JSISCO تحويل احتياجاتك الطاقوية',
      button:   'احصل على عرض مجاني',
      phone:    'أو اتصل بنا',
    },
    services: {
      title:          'خدماتنا',
      subtitle:       'حلول متخصصة للطاقة المتجددة والأعمال الكهربائية لكل احتياج',
      solar:          'تركيب أنظمة الطاقة الشمسية',
      solarDesc:      'تصميم وتركيب احترافي لأنظمة الطاقة الشمسية للمنازل والمنشآت التجارية والصناعية',
      renewable:      'حلول الطاقة المتجددة',
      renewableDesc:  'استشارات وتصميم وتنفيذ شامل لمشاريع الطاقة المتجددة',
      monitoring:     'أنظمة المراقبة والحماية',
      monitoringDesc: 'أنظمة مراقبة وتحكم وحماية متطورة للتركيبات الكهربائية والشمسية',
      electrical:     'الأعمال الكهربائية',
      electricalDesc: 'أعمال كهربائية شاملة تشمل الأسلاك واللوحات والمحولات وشبكات التوزيع',
      maintenance:    'الصيانة الصناعية',
      maintenanceDesc:'صيانة وقائية وتصحيحية للأنظمة الكهربائية والميكانيكية الصناعية',
      fireAlarm:      'أنظمة إنذار الحريق',
    },
    projects: {
      title:   'مشاريعنا',
      subtitle: 'محفظة مشاريع ناجحة في جنوب الأردن',
      seeMore: 'عرض المشروع',
    },
    about: {
      title:    'من نحن',
      subtitle: 'شركة الجنوب للأنظمة المتكاملة — شريكك الموثوق في الطاقة المتجددة',
      credential: {
        years:          '2017 – 2026',
        classification: 'شركة من الفئة (أ) — مرخّصة من هيئة تنظيم قطاع الطاقة والمعادن (رخصة رقم 58)',
        unique:         'الشركة الوحيدة المجهزة بالكامل لتركيب الأنظمة في إقليم الجنوب الأردني.',
      },
      ourStory: {
        title:    'قصتنا',
        content:  'تأسست JSISCO برؤية واضحة: تقديم حلول طاقة موثوقة وميسورة التكلفة ومستدامة لجنوب الأردن. بدأنا بالأعمال الكهربائية ثم توسّعنا سريعاً في أنظمة الطاقة الشمسية والصيانة الصناعية.',
        content2: 'اليوم نحن من الشركات الرائدة في قطاع الطاقة المتجددة في المنطقة، مع مئات المشاريع المنجزة بنجاح وفريق من المهندسين والفنيين المعتمدين الملتزمين بالتميّز.',
        content3: 'بفضل خبرتنا الواسعة في مختلف المجالات، نقدم حلولاً ذكية في شكل أنظمة وبرامج مصممة للحفاظ على الطاقة وخفض التكاليف لعملائنا، لمساعدتهم على تبني حلول موفرة للطاقة تدعم أسلوب حياة سلس واقتصادي.',
      },
      mission: {
        title:   'مهمتنا',
        content: 'قيادة التحول المجتمعي نحو تبني الطاقة المتجددة من خلال تقديم أنظمة طاقة بديلة موثوقة وفعالة ومتطورة. نسعى لتشجيع الأفراد والشركات والمؤسسات على تطبيق حلول الطاقة النظيفة التي تقلل من آثار التغير المناخي وتساهم في مستقبل أكثر استدامة.',
      },
      vision: {
        title:   'رؤيتنا',
        content: 'أن نجعل الطاقة المتجددة في متناول الجميع ونساهم في مستقبل خالٍ من الوقود الأحفوري.',
      },
      values: {
        title: 'قيمنا',
        customerService:      { title: 'خدمة العملاء',        content: 'دعم سريع ومهتم في كل مرحلة من مراحل المشروع' },
        innovation:            { title: 'الابتكار',            content: 'نتبنّى أحدث التقنيات في مجال الطاقة المتجددة' },
        teamwork:              { title: 'العمل الجماعي',       content: 'نتعاون معاً كفريق واحد لإنجاز كل مشروع' },
        sustainability:        { title: 'الاستدامة',           content: 'نبني مستقبلاً أنظف وأكثر استدامة للطاقة' },
        customerSatisfaction: { title: 'رضا العملاء',         content: 'نسعى لنتائج تتجاوز توقعات عملائنا' },
        qualityOfService:     { title: 'جودة الخدمة',         content: 'ملتزمون بأعلى المعايير في كل مشروع' },
        commitment:            { title: 'الالتزام',            content: 'متابعة موثوقة من التخطيط وحتى الإنجاز' },
        professionalism:       { title: 'الاحترافية والكفاءة', content: 'مهندسون وفنيون معتمدون ملتزمون بالتميّز' },
      },
      community: {
        title:         'تمكين المجتمع',
        subtitle:      'بناء القدرات وتطوير الكوادر',
        intro:         'في JSISCO، نؤمن بأن التحول نحو الطاقة المستدامة يبدأ بتمكين الأفراد. نستثمر بفعالية في تطوير الكفاءات الشابة وتعزيز القدرات الفنية المحلية في قطاع الطاقة المتجددة.',
        quote:         'الطاقة قابلة للاستهلاك، أما إمكانات الإنسان فهي قابلة للتوسع. نحن نستثمر في كليهما.',
        programsTitle: 'برامج التدريب',
        programs: [
          { title: 'التركيب الميداني والتنفيذ العملي', desc: 'تدريب عملي على تركيب الأنظمة الشمسية والتنفيذ الميداني.' },
          { title: 'التدريب التقني وبرامج الحاسوب',      desc: 'AutoCAD وSketchUp وأنظمة مراقبة وتصميم الطاقة الشمسية.' },
          { title: 'الصحة والسلامة المهنية',             desc: 'معايير السلامة المهنية وممارسات الوقاية من المخاطر.' },
        ],
        stats: {
          hussein: { number: '25', label: 'طالب من جامعة الحسين بن طلال' },
          balqa:   { number: '10', label: 'طالب من جامعة البلقاء التطبيقية والكليات المجتمعية' },
        },
        employment: { title: 'فرصة توظيف', desc: 'تم توظيف بعض المتدربين المميزين وهم يعملون حالياً في JSISCO.' },
      },
    },
    contact: {
      title:   'اتصل بنا',
      subtitle: 'نحن هنا للإجابة على أسئلتك ومساعدتك في البدء',
      success: 'شكراً لك! سنتواصل معك خلال 24 ساعة.',
      error:   'حدث خطأ ما. يرجى المحاولة مرة أخرى أو الاتصال بنا مباشرة.',
      form: {
        name:    'اسمك',
        email:   'البريد الإلكتروني',
        phone:   'رقم الهاتف',
        subject: 'الموضوع',
        message: 'رسالتك',
        submit:  'إرسال الرسالة',
      },
      info: {
        title:      'معلومات الاتصال',
        phone:      'الهاتف',
        email:      'البريد الإلكتروني',
        address:    'العنوان',
        hours:         'ساعات العمل',
        hoursWeekdays: 'من الأحد إلى الخميس، والسبت',
        hoursShifts:   'من 9:00 ص إلى 3:00 م، ومن 5:00 م إلى 10:00 م',
        hoursFriday:   'الجمعة: مغلق',
        social:     'تابعنا',
      },
    },
    quote: {
      title:   'طلب عرض سعر مجاني',
      subtitle: 'أخبرنا عن مشروعك وسنتواصل معك خلال 24 ساعة',
      success: 'تم إرسال طلب العرض بنجاح! سنتواصل معك خلال 24 ساعة.',
      error:   'فشل الإرسال. يرجى المحاولة مرة أخرى أو الاتصال بنا مباشرة.',
      form: {
        name:            'الاسم الكامل',
        email:           'البريد الإلكتروني',
        phone:           'رقم الهاتف',
        company:         'الشركة / المؤسسة',
        serviceType:     'الخدمة المطلوبة',
        selectService:   'اختر خدمة',
        projectDetails:  'تفاصيل المشروع',
        budget:          'الميزانية التقديرية (دينار)',
        timeline:        'الجدول الزمني المتوقع',
        attachments:     'المرفقات',
        attachmentsNote: 'أرفق المستندات ذات الصلة (5 ملفات كحد أقصى، 5 ميجابايت لكل منها)',
        submit:          'إرسال الطلب',
      },
    },
    footer: {
      description: 'شركة الجنوب للأنظمة المتكاملة — متخصصون في الطاقة المتجددة وتركيب أنظمة الطاقة الشمسية والأعمال الكهربائية والصيانة الصناعية.',
      quickLinks:  'روابط سريعة',
      services:    'الخدمات',
      contact:     'اتصل بنا',
      rights:      'جميع الحقوق محفوظة',
      registration: 'الرقم الوطني للمنشأة: 200159018',
    },
    partners: {
      strategicTitle: 'شركاء استراتيجيون',
      suppliersTitle: 'شركاؤنا وموردونا المعتمدون',
      viewInitiative: 'عرض المبادرة',
      maan: {
        name: 'بلدية معان الكبرى',
        desc: 'نتعاون مع بلدية معان الكبرى في مبادرة فرز النفايات والمبادرة البيئية في معان.',
      },
    },
    sustainability: {
      badge:    'مبادرة بيئية',
      title:    'الاستدامة والمسؤولية المجتمعية',
      subtitle: 'نحو معان أجمل وأنظف',
      socialResponsibility: {
        intro:   'في JSISCO، نعمل بمسؤولية لمواجهة التحديات البيئية والاجتماعية.',
        points: [
          'تقليل الانبعاثات الكربونية',
          'دعم أنظمة تنقية المياه المستدامة',
          'تعزيز الوعي بالطاقة النظيفة',
          'بناء قيمة طويلة الأمد لعملائنا وموظفينا ومجتمعاتنا',
        ],
        closing: 'مسؤوليتنا لا تقتصر على المشاريع، بل تمتد لتشمل الأثر.',
      },
      initiative: {
        title: 'محطة فرز النفايات في معان',
        body:  'شركة الجنوب للأنظمة المتكاملة تباشر العمل في جمع الكرتون استعداداً لتشغيل محطة فرز النفايات في معان، كخطوة أولى لعمليات فرز وجمع النفايات من المصدر، والتي ستشمل مخلفات أخرى إن شاء الله، سعياً للتخفيف من التلوث البيئي، نحو معان أجمل وأنظف.',
      },
      partner: {
        label: 'بالتعاون والتشارك مع',
        name:  'بلدية معان الكبرى',
      },
      participate: {
        title: 'كيف يمكنك المساعدة',
        steps: [
          { title: 'افرز من المصدر',       desc: 'افصل الكرتون والمواد القابلة لإعادة التدوير في منزلك أو منشأتك قبل التخلص منها.' },
          { title: 'استخدم الحاويات المخصصة', desc: 'ضع النفايات المفروزة في الأماكن المخصصة للنفايات المفروزة، وليس في حاويات الشارع العادية.' },
          { title: 'قريباً... مواد أخرى',  desc: 'سيتوسع المشروع تدريجياً ليشمل مواد أخرى قابلة لإعادة التدوير إن شاء الله.' },
        ],
      },
      cta: {
        title:    'هل تريد دعم هذه المبادرة؟',
        subtitle: 'سواء كنت من سكان معان أو صاحب عمل أو مؤسسة، تواصل معنا لمعرفة كيف يمكنك المشاركة.',
      },
    },
    admin: {
      login: {
        title:       'لوحة تحكم JSISCO',
        subtitle:    'أدخل كلمة المرور للمتابعة',
        placeholder: 'كلمة المرور',
        incorrect:   'كلمة المرور غير صحيحة',
        submit:      'دخول',
      },
      header: {
        title:    'لوحة تحكم JSISCO',
        subtitle: 'لوحة الطلبات والرسائل',
        logout:   'تسجيل الخروج',
      },
      tabs: {
        contacts: 'رسائل التواصل',
        quotes:   'طلبات عروض الأسعار',
      },
      loading:         'جاري التحميل…',
      connectionError: 'تعذر الاتصال بالخادم. تأكد من أنه يعمل.',
      noSubmissions:   'لا توجد طلبات بعد',
      fields: {
        name:         'الاسم',
        email:        'البريد الإلكتروني',
        phone:        'الهاتف',
        subject:      'الموضوع',
        status:       'الحالة',
        date:         'التاريخ',
        service:      'الخدمة',
        budget:       'الميزانية',
      },
      detail: {
        message:        'الرسالة',
        projectDetails: 'تفاصيل المشروع',
      },
      status: {
        pending:          'قيد الانتظار',
        contacted:        'تم التواصل',
        resolved:         'تم الحل',
        reviewed:         'تمت المراجعة',
        quoted:           'تم إرسال عرض',
        accepted:         'مقبول',
        rejected:         'مرفوض',
      },
    },
  },
};

export default translations;
